export default __webpack_public_path__ + "static/media/meta.4838a5da.png";